/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import Tier from './Tier'
import Photochromatic from './Photochromatic'
import { isEmptyHtml } from '@/utils/html'
import { toDisplayCondition } from '@/utils/display-condition'
import { ServiceTypes } from '@/enums'
import KImage from '@/types/KImage'

const EXCEPTIONS = ['bltf03ad1e54c2024dc']

export default class Answer {
  private json: any
  public readonly name: string // this is the Contentstack item name
  public readonly uid: string
  public readonly nextQuestionId?: string
  public readonly hasMoreInfo: boolean
  public readonly hasPhotochromatic: boolean
  public readonly photochromatic?: Photochromatic
  public readonly hasTiers: boolean
  public readonly isExclusive: boolean
  public readonly image?: KImage
  public readonly labelBackButton: string
  public readonly heading: string
  public readonly description: string
  public readonly moreInfo: string
  public readonly tiers: Tier[]
  public readonly retailPrice?: number
  public readonly procedureCode?: string
  public readonly serviceType?: ServiceTypes
  public readonly displayCondition: string[]

  constructor (json: any, nextQuestionUid?: string) {
    this.uid = json.answers[0].uid
    this.name = json.answers[0].title
    this.nextQuestionId = nextQuestionUid || json.next_question[0]?.uid
    this.hasMoreInfo = !isEmptyHtml(json.answers[0].educational_material)
    this.hasTiers = !!json.answers[0].sub_options.length
    this.isExclusive = !!json.answers[0].deselect_other

    const imageInformation = json.answers[0].image
    if (imageInformation.answer_image) {
      this.image = new KImage(
        imageInformation.answer_image.url,
        imageInformation.answer_image.content_type,
        imageInformation.alt_text
      )
    }

    this.labelBackButton = json.answers[0].label_back_to_options
    this.heading = json.answers[0].heading
    this.description = json.answers[0].description
    this.moreInfo = json.answers[0].educational_material
    this.tiers = json.answers[0].sub_options.map(Tier.of)
    this.serviceType = json.answers[0].service_type
    this.displayCondition = toDisplayCondition(json.answers[0].display_condition)

    this.hasPhotochromatic = json.answers[0].education_slider?.slider_images.length > 0
    if (this.hasPhotochromatic) {
      this.photochromatic = Photochromatic.of(json.answers[0].education_slider)
    }

    const jsonProcedureCode = json.answers[0].procedure_code[0]
    if (jsonProcedureCode) {
      this.retailPrice = Number.parseFloat(jsonProcedureCode.retail_price)
      this.procedureCode = jsonProcedureCode.procedure_code
      if (!EXCEPTIONS.some(e => json.answers[0].uid === e)) {
        this.name = jsonProcedureCode.title
      }
    }
  }

  static of (json: any, nextQuestionUid?: string): Answer {
    return new Answer(json, nextQuestionUid)
  }
}
